/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Drift_Step_3Inputs */

const en_landing_drift_step_3 = /** @type {(inputs: Landing_Drift_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit 3 · add a bud vase`)
};

const zh_landing_drift_step_3 = /** @type {(inputs: Landing_Drift_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑 3 · 添加小花瓶`)
};

/**
* | output |
* | --- |
* | "Edit 3 · add a bud vase" |
*
* @param {Landing_Drift_Step_3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_drift_step_3 = /** @type {((inputs?: Landing_Drift_Step_3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Drift_Step_3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_drift_step_3(inputs)
	return zh_landing_drift_step_3(inputs)
});
export { landing_drift_step_3 as "landing.drift.step_3" }